// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseComponent } from '../../../../../com/MetaPattern/MDA/MD/Base/BaseComponent';
import { ViewObject } from './ViewObject';
import { UIPageGroup } from './UIPageGroup';
import { PageView } from './PageView';
import { UIView } from './UIView';
import { UIButton } from './UIButton';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { UIModelComponentExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/UIModel/UIModelComponentExtend';
/**
 * UI模型组件 实体类
 * UI模型组件
 */
export class UIModelComponent extends BaseComponent {
  /** 绑定标志 : 绑定元素的标志，使用设计期ID，用于区分自动生成情况下的来源 */
  private _bindingCode: string;

  /** 设置：绑定标志 */
  public get bindingCode() {
    return this._bindingCode;
  }

  /** 获取：绑定标志 */
  public set bindingCode(value: string) {
    this._bindingCode = value;
  }

  /** 视图对象 */
  private _viewObjects: Array<ViewObject>;

  /** 获取：视图对象 */
  public get viewObjects() {
    return this._viewObjects;
  }

  /** 设置：视图对象 */
  public set viewObjects(value: Array<ViewObject>) {
    this._viewObjects = value;
  }

  /** 页面分组 */
  private _pageGroups: Array<UIPageGroup>;

  /** 获取：页面分组 */
  public get pageGroups() {
    return this._pageGroups;
  }

  /** 设置：页面分组 */
  public set pageGroups(value: Array<UIPageGroup>) {
    this._pageGroups = value;
  }

  /** 页面视图 */
  private _pageViews: Array<PageView>;

  /** 获取：页面视图 */
  public get pageViews() {
    return this._pageViews;
  }

  /** 设置：页面视图 */
  public set pageViews(value: Array<PageView>) {
    this._pageViews = value;
  }

  /** 视图 */
  private _views: Array<UIView>;

  /** 获取：视图 */
  public get views() {
    return this._views;
  }

  /** 设置：视图 */
  public set views(value: Array<UIView>) {
    this._views = value;
  }

  /** 按钮 */
  private _buttons: Array<UIButton>;

  /** 获取：按钮 */
  public get buttons() {
    return this._buttons;
  }

  /** 设置：按钮 */
  public set buttons(value: Array<UIButton>) {
    this._buttons = value;
  }

  constructor() {
    super();
    UIModelComponentExtend.Init(this);
    this._bindingCode = '';
    this._viewObjects = new Array<ViewObject>();
    this._pageGroups = new Array<UIPageGroup>();
    this._pageViews = new Array<PageView>();
    this._views = new Array<UIView>();
    this._buttons = new Array<UIButton>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: UIModelComponent, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.bindingCode = element.bindingCode;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.bindingCode = json.BindingCode;
    if (json.ViewObjects && json.ViewObjects.length > 0) {
      json.ViewObjects.forEach((element: any) => {
        const viewObject = ViewObject.Create(element);
        // viewObject.component = this;
        this.viewObjects.push(viewObject);
      });
    }
    if (json.PageGroups && json.PageGroups.length > 0) {
      json.PageGroups.forEach((element: any) => {
        const uIPageGroup = UIPageGroup.Create(element);
        // uIPageGroup.component = this;
        this.pageGroups.push(uIPageGroup);
      });
    }
    if (json.PageViews && json.PageViews.length > 0) {
      json.PageViews.forEach((element: any) => {
        const pageView = PageView.Create(element);
        // pageView.component = this;
        this.pageViews.push(pageView);
      });
    }
    if (json.Views && json.Views.length > 0) {
      json.Views.forEach((element: any) => {
        const uIView = UIView.Create(element);
        // uIView.component = this;
        this.views.push(uIView);
      });
    }
    if (json.Buttons && json.Buttons.length > 0) {
      json.Buttons.forEach((element: any) => {
        const uIButton = UIButton.Create(element);
        // uIButton.component = this;
        this.buttons.push(uIButton);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.BindingCode = this.bindingCode;
    if (this.viewObjects && this.viewObjects.length > 0) {
      json.ViewObjects = [];
      this.viewObjects.forEach((element) => {
        json.ViewObjects.push(element.toJson());
      });
    }
    if (this.pageGroups && this.pageGroups.length > 0) {
      json.PageGroups = [];
      this.pageGroups.forEach((element) => {
        json.PageGroups.push(element.toJson());
      });
    }
    if (this.pageViews && this.pageViews.length > 0) {
      json.PageViews = [];
      this.pageViews.forEach((element) => {
        json.PageViews.push(element.toJson());
      });
    }
    if (this.views && this.views.length > 0) {
      json.Views = [];
      this.views.forEach((element) => {
        json.Views.push(element.toJson());
      });
    }
    if (this.buttons && this.buttons.length > 0) {
      json.Buttons = [];
      this.buttons.forEach((element) => {
        json.Buttons.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): UIModelComponent {
    const uIModelComponent = new UIModelComponent();
    uIModelComponent.Deserialize(json);
    uIModelComponent.json = json;
    return uIModelComponent;
  }
}
